import styled from 'styled-components';
import { px2rem } from '@stylesheets/tools';
import { fontFamilies } from '../../../../stylesheets/settings';

const StyledEducationRefinementReset = styled.div`
  button {
    font-size: ${px2rem('18px')};
    font-family: ${fontFamilies.default};
    text-decoration: underline;
    color: black;
  }
`;

export default StyledEducationRefinementReset;
